import { BlockList } from '@anwb/poncho/components/block-list';
import { pxToRem } from '@anwb/poncho/design-tokens/style-utilities';
import styled, { DefaultThemeProps, css } from 'styled-components';

const StyledBlockList = styled(BlockList)<DefaultThemeProps>`
	${({ theme }) => css`
		margin-bottom: ${pxToRem(theme.spacing['400'])};
	`}
`;

export default StyledBlockList;
